import { PropsWithChildren } from 'react'

import { OneOnOnesContextDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { MeetingBecomeErrorLayout } from 'modules/meetings/components/Layout/MeetingBecomeErrorLayout'
import { OneOnOnesContext } from 'modules/meetings/lib/context/OneOnOnesContext'

export const OneOnOnesContextProvider = ({ children }: PropsWithChildren) => {
  const { data, loading } = useQuery(OneOnOnesContextDocument)
  const { isAdminBecome, isStaffBecome } = useCurrentSession()

  const canSeeMeetings = data?.meetings._policies.seeMeetings.can ?? false
  const canSeeAdvancedMeetings = data?.meetings._policies.seeAdvancedMeetings.can ?? false
  const isBecome = isAdminBecome || isStaffBecome

  const value = {
    canSeeMeetings,
    canSeeAdvancedMeetings,
    isBecome,
    loading,
  }

  if (isBecome) {
    return <MeetingBecomeErrorLayout />
  }

  return <OneOnOnesContext.Provider value={value}>{children}</OneOnOnesContext.Provider>
}
